import Home from './pages/Home.svelte';
import Home2 from './pages/Home2.svelte';
import AboutUs from './pages/AboutUs.svelte';
import Activities from './pages/Activities.svelte';
import Blogs from './pages/Blogs.svelte';
import Resources from './pages/Resources.svelte';
import ContactUs from './pages/ContactUs.svelte';
import BlogPage from './pages/BlogPage.svelte';
import NotFound from './pages/NotFound.svelte';
import PrivacyPolicy from './pages/PrivacyPolicy.svelte';
import TandC from './pages/TandC.svelte';

export default [
    { url: '/', title: '', component: Home, navbar_label: 'Home', },
    { url: '/about-us', title: 'About Us', component: AboutUs, },
    // { url: '/activities', title: 'Activities', component: Activities, },
    { url: '/blog', title: 'Blogs', component: Blogs, },
    { url: '/blog/:id', title: 'Blog', component: BlogPage, hide_in_navbar: true, },
    { url: '/resources', title: 'Resources', component: Resources, },
    { url: '/contact-us', title: 'Contact Us', component: ContactUs, },
    { url: '/privacy-policy', title: 'Privacy Policy', component: PrivacyPolicy, hide_in_navbar: true, },
    { url: '/terms-and-conditions', title: 'TandC', component: TandC, hide_in_navbar: true, },
    { url: '*', title: 'Page Not Found', component: NotFound, hide_in_navbar: true, },
];
